import React, {Component} from 'react';
import {Icon, Button} from 'semantic-ui-react'
import _ from 'lodash'

export default class RenderHtml extends Component {

    static renderError(state) {
        let {errorMessage, id, uuid} = state;
        if (!id) id = uuid;

        if (errorMessage && !_.isEmpty(errorMessage)) {
            return <div className="app-form-error-container" id={"app_form_error_" + id}>
                {errorMessage}
            </div>
        }

        return null
    }

    static renderLabel(label, dropdown, button) {
        if (label && !_.isEmpty(label) && !dropdown && !button) {
            return _.isString(label) ? {label: label} : {label: label.text, labelPosition: label.position}
        }

        return {}
    }

    static renderIcon(icon) {
        if (icon && !_.isEmpty(icon)) {
            return <Icon><i className={`fal fa-${icon}`} /></Icon>
        }

        return {}
    }

    static renderAddon(state, val) {
        let {addon, id, uuid} = state;
        if (!id) id = uuid;
        if (val && _.find(addon, {position: val})) {
            return <span className={'input-group-addon ' + val} id={"ariaFirst" + id}>{_.find(addon, {position: val}).text}</span>
        }
        return ''
    }

    static renderTitle(state) {
        let {title, id, uuid} = state;
        if (!id) id = uuid;
        if (title && !_.isEmpty(title)) {
            return <div className="app-component-form-title" id={"app_form_title_" + id}>{title}</div>
        }

        return null
    }

    static renderTitleAfterElement(state) {
        let {title} = state;

        if (title && !_.isEmpty(title)) {
            return title
        }

        return null
    }

    static renderCaption(state) {
        let {caption, id, uuid, multiSelect, multiData, dataShowFields} = state;

        let labelClass = '';

        if (!id) id = uuid;
        if (caption && !_.isEmpty(caption)) {
            return <div className={`app-placeholder-label ${labelClass}`} id={"app_form_label_" + id}>{caption}</div>
        }
        return null
    }

    static renderId(state) {
        let {id, uuid} = state;
        if (!id) id = 'input_id_' + uuid;

        return id;
    }

    static renderName(state) {
        let {name, uuid} = state;
        if (!name) name = 'input_name_' + uuid;

        return name;
    }


}
